import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  EntityGroupPickerProps,
  TextBuildingBlockGroupPicker,
} from '@work4all/components/lib/components/entity-picker/entity-group-picker/EntityGroupPicker';
import { PickerTargetButton } from '@work4all/components/lib/input/picker-target-button';

import { reactRefSetter } from '@work4all/utils';

interface Props extends Omit<EntityGroupPickerProps, 'entity' | 'multiple'> {
  error?: string;
  disabled?: boolean;
}

export const TextBuildingBlockGroupPickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const wrapperRef = useRef(null);

  const { t } = useTranslation();

  const { disabled, error, ...pickerProps } = props;
  const { value } = pickerProps;
  const displayValue = value && value.length > 0 ? value?.[0]?.name : '';

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        anchorEl={wrapperRef}
        disabled={disabled}
        picker={
          <TextBuildingBlockGroupPicker {...pickerProps} multiple={false} />
        }
      >
        <PickerTargetButton
          label={t('COMMON.GROUP')}
          error={error}
          disabled={disabled}
          value={displayValue}
          onClear={() => props.onChange(null)}
        />
      </EntityPickerPopover>
    </div>
  );
});
